import React, {useState, useEffect} from 'react';
import 'fontsource-roboto';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

export default function StepForm(props) {
  const [fields, setFields] = useState({});

  useEffect(() => {
    if (Object.keys(props.step.fields).length > 0 && Object.keys(fields).length === 0)
      setFields(Object.assign(...Object.keys(props.step.fields).map(key => ({[key]: props.step.fields[key].value}))));
  }, [props, fields]);

  const handleFieldValueChange = (e) => {
    setFields({...fields, [e.target.name]: e.target.value});
  };

  const handleStepComplete = () => {
    props.onChange(fields);
  };

  return (
    <Grid container spacing={1} alignItems='stretch'>
      {Object.keys(fields).map((fieldName, index) => {
        return <Grid key={index} item xs={12} sm={6} md={4}>
          <TextField margin='none'
            autoFocus={index === 0}
            type={props.step.fields[fieldName].type}
            required={props.step.fields[fieldName].isRequired}
            label={props.step.fields[fieldName].label}
            placeholder={props.step.fields[fieldName].label}
            name={fieldName}
            value={fields[fieldName]}
            onChange={handleFieldValueChange}
            InputProps={props.step.fields[fieldName].InputProps || {}}
          />
        </Grid>
      }
      )}
      <Grid item xs={12}>
        <Box style={{float: 'right'}}>
          <Button variant='contained' color='primary'
            onClick={handleStepComplete}
          >
            Continua
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
}